import React, {useState, useEffect} from 'react';

import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Table from 'react-bootstrap/Table';
import { useDispatch, useSelector } from 'react-redux';

import { checkout, checkCoupon } from '../services/Cart';
import { reserveDomain, releaseDomain } from '../services/LinkolnDomains';
import { fetchCart, fetchLinkolnDomains } from '../store/resources';
import CartDomain from './CartDomain';

const SUBDOMAIN_PRICE = 7;
const CUSTOM_DOMAIN_PRICE = 9;


export default function BuyDomains() {
  const dispatch = useDispatch();
  const linkoln_domains = useSelector(state => state.linkolnDomains);
  const cart = useSelector(state => state.cart);

  const [custom_domain_credits, setCustomDomainCredits] = useState(0);
  const [domain, setDomain] = useState("");
  const [subdomain, setSubDomain] = useState("");
  const [couponCode, setCouponCode] = useState("");
  const [appliedCoupon, setAppliedCoupon] = useState(null);

  useEffect(() => {
    dispatch(fetchLinkolnDomains());
    dispatch(fetchCart());
  }, [dispatch]);

  useEffect(() => {
    setDomain(linkoln_domains[0] || "");
  }, [linkoln_domains]);

  // A coupon makes one item of its product type free.
  let discount = 0;
  if (appliedCoupon?.product === "linkoln_subdomain" && cart.length > 0) {
    discount = SUBDOMAIN_PRICE;
  } else if (appliedCoupon?.product === "custom_domain" && custom_domain_credits > 0) {
    discount = CUSTOM_DOMAIN_PRICE;
  }
  const cart_total = cart.length * SUBDOMAIN_PRICE + custom_domain_credits * CUSTOM_DOMAIN_PRICE - discount;

  const checkOut = async () => {
    const result = await checkout(cart, custom_domain_credits, appliedCoupon ? couponCode : undefined);
    if (result.status === "redirect") {
      window.location.replace(result.url);
    } else if (result.status === "refresh") {
      alert("Some of the domains you chose may have expired, please select them again.");
      window.location.reload();
    } else if (result.status === "error") {
      alert("There was an error processing the order.");
    }
  };

  const checkCouponCode = async () => {
    const coupon = await checkCoupon(couponCode);
    if (!coupon.is_valid) {
      alert("Invalid or expired coupon code.");
    } else if (coupon.product === "linkoln_subdomain" && cart.length === 0) {
      alert("You must add a Linkoln subdomain to your cart to apply this coupon.");
    } else if (coupon.product === "custom_domain" && custom_domain_credits === 0) {
      alert("You must add a custom domain credit to your cart to apply this coupon.");
    } else {
      setAppliedCoupon(coupon);
    }
  };

  const removeDomain = async (full_domain) => {
    const [this_subdomain, ...rest] = full_domain.split(".");
    await releaseDomain(rest.join('.'), this_subdomain);
    dispatch(fetchCart());
  };

  const addSubdomain = async () => {
    if (!domain) {
      alert("You must select a domain");
      return;
    }
    const result = await reserveDomain(domain, subdomain);
    if (result.status === "taken") {
      alert(subdomain + "." + domain + " is already taken");
    }
    setSubDomain("");
    dispatch(fetchCart());
  };

  return (
    <>
    <div className="container-md px-0">
      <Row>
        <Col>
          <h1>Choose Your Domains</h1>
          <p>You need a domain to create links.  The domain(s) you choose will be used for your links.</p>
        </Col>
      </Row>
    </div>
    <div className="container-md px-0">
      <div className="row">
        <div className="col-12">
            <Form onSubmit={(e) => e.preventDefault()}>
            <div className="row">
              <div className="col-md mb-4">
                <div className="shadow rounded p-3 h-100 text-center">
                    <h3 className="bg-secondary text-white p-2 text-center text-capitalize">Add a domain you already own</h3>
                    <p className="fs-4 fw-bold text-capitalize">${CUSTOM_DOMAIN_PRICE} one-time fee</p>
                    <p>This process involves setting up DNS records for your domain.  If you are not comfortable doing so, this option might not be for you.</p>
                    <Button variant="danger my-3" onClick={() => setCustomDomainCredits(custom_domain_credits + 1)}>Add credit for custom domain</Button>
                </div>
              </div>
              <div className="col-md mb-4">
                <div className="shadow rounded p-3 h-100 text-center">
                <h3 className="bg-secondary text-white p-2 text-center text-capitalize">Add a Linkoln subdomain</h3>
                <p className="fs-4 fw-bold text-capitalize">${SUBDOMAIN_PRICE} one-time fee</p>
                  <div className="row d-flex align-items-end">
                    <div className="col-sm text-start">
                    <Form.Label>Subdomain:</Form.Label>
                        <Form.Control as="input" onChange={(e) => setSubDomain(e.target.value)} value={subdomain}/>
                    </div>
                    <div className="col-sm text-start">
                        <Form.Label>Domain:</Form.Label>
                        <Form.Select onChange={(e) => setDomain(e.target.value)} value={domain}>
                        {linkoln_domains.map(name => (
                          <option value={name} key={name}>{name}</option>
                        ))}
                        </Form.Select>
                    </div>
                    <div className="col-sm">
                      <Button variant="danger mt-4 mt-sm-0" onClick={addSubdomain}>Add subdomain</Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        </div>
      </div>


      <div className="row">
        <div className="col-12">
            <h3>Cart - Total: ${cart_total}</h3>
          <Table striped bordered responsive className="bg-white">
            <thead className="thead-dark">
                <tr><th>Item</th><th>&nbsp;</th></tr>
            </thead>
            <tbody>
            {custom_domain_credits > 0 && (
                <tr>
                  <td>Custom Domain Credits: {custom_domain_credits}</td>
                  <td><Button variant="danger" onClick={() => setCustomDomainCredits(0)}>Remove</Button></td>
                </tr>
            )}
            {cart.map(full_domain => (
              <CartDomain key={full_domain} domain={full_domain} removeDomain={removeDomain}/>
            ))}
            </tbody>
          </Table>
          <div className="row">
            <div className="col-12">
              <div className="col-sm text-start">
                <Form.Label>Coupon:</Form.Label>
                <Form.Control as="input" onChange={(e) => setCouponCode(e.target.value)} value={couponCode}/>
              </div>
              <div className="col-sm text-start">
                <Button variant="danger" onClick={checkCouponCode}>Apply Coupon</Button>
              </div>
              <div className="col-sm text-start">
                <Button variant="danger" onClick={checkOut}>Checkout</Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
}
